<template>
    <div class="carzRangeSearch">
        <div class="carzRangeSearchFilterBar" ref="filter">
            <div class="carzRangeSearchFilterBar__wrap">
                <div class="carzRangeSearchFilterBar__filters">
                    <div class="carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap">
                        <label for="make" class="sr-only">Make</label>
                        <select name="make" class="carzRangeSearchFilterBar__select" @change="onMakeChange($event.target.value)">
                            <option value="">Make</option>
                            <option v-for="make in filters.makes"
                                    :value="make.value"
                                    :key="make.value"
                            >
                                {{ make.name }}
                            </option>

                        </select>
                    </div>


                    <div class="carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap">
                        <label for="model" class="sr-only">Model</label>
                        <select name="model" class="carzRangeSearchFilterBar__select" :disabled="!params.make" @change="onFilterChange('model', $event.target.value)">
                            <option value="">Model</option>
                            <option v-for="model in filters.models"
                                    :value="model.value"
                                    :key="model.value"
                            >
                                {{ model.name }}
                            </option>
                        </select>
                    </div>

                    <div class="carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap">
                        <label for="fuel" class="sr-only">Fuel</label>
                        <select name="fuel" class="carzRangeSearchFilterBar__select" @change="onFilterChange('fuel', $event.target.value)">
                            <option value="">Fuel type</option>
                            <option v-for="fuel in filters.fuel"
                                    :value="fuel.value"
                                    :key="fuel.value"
                            >
                                {{ fuel.name }}
                            </option>
                        </select>
                    </div>

                    <div class="carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap carzRangeSearchFilterBar__priceBoxWrap">

                        <button type="button" class="carzRangeSearchFilterBar__priceBoxTrigger" @click="onPriceBoxChange">
                            {{ priceRangeContext }}
                        </button>

                        <div class="carzRangeSearchFilterBar__priceBox" v-show="isPriceBoxOpen">
                            <div class="carzRangeSearchFilterBar__priceBoxToggle">
                                <button v-for="type in filters.priceTypes" 
                                        type="button"
                                        class="carzRangeSearchFilterBar__priceBoxButton"
                                        :class="{ 'carzRangeSearchFilterBar__priceBoxButton--active': type.value === params.priceType }"
                                        @click.stop="onPriceTypeChange(type.value)"
                                >
                                    {{ type.name }}
                                </button>
                            </div>

                            <div class="carzRangeSearchFilterBar__priceBoxRange">
                                <div class="carzRangeSearchFilterBar__priceBoxSelectWrap">
                                    <label for="priceFrom">Price from</label>
                                    <div class="carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap">
                                        <select name="price_from" class="carzRangeSearchFilterBar__select" @change="onFilterChange('priceFrom', $event.target.value)">
                                            <option value="">Select</option>
                                            <option v-for="price in priceRangeFrom"
                                                    :value="price.value"
                                                    :key="price.label"
                                            >
                                                {{ formatCurrency(price.label) }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="carzRangeSearchFilterBar__priceBoxSelectWrap">
                                    <label for="priceFrom">Price to</label>
                                    <div class="carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap">
                                        <select name="price_to" class="carzRangeSearchFilterBar__select" @change="onFilterChange('priceTo', $event.target.value)">
                                            <option value="">Select</option>
                                            <option v-for="price in priceRangeTo"
                                                    :value="price.value"
                                                    :key="price.label"
                                            >
                                                {{ formatCurrency(price.label) }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    
                    <!-- <button class="carzRangeSearchFilterBar__searchButton" -->
                    <!--         :class="{ 'carzRangeSearchFilterBar__searchButton--disabled' : loading }" -->
                    <!--         :disabled="loading" -->
                    <!--         @click="fetchVehicles" -->
                    <!-- > -->
                    <!--     Apply filters -->
                    <!-- </button> -->
                </div>
            </div>
        </div>
        
        <div class="carzRangeSearchPage__vehicleCardsGrid vehicleCardsGrid vehicleCardsGrid--fullWidth vehicleCardsGrid--isGrid" v-if="!loaded">
            <VehicleCardLoading
                v-for="index in loadingPlaceholders"
                :key="index"
            />
        </div>


        <div class="carzRangeSearchPage__vehicleCardsGrid vehicleCardsGrid vehicleCardsGrid--fullWidth vehicleCardsGrid--isGrid" v-else-if="vehicles.length > 0">
            <AutonomyVehicleCard v-for="vehicle in vehicles" :key="vehicle.id" :vehicle="vehicle" :zero-payment-settings="zeroPaymentSettings" />
        </div>

        <div class="carzRangeSearchPage__emptyResults" v-else>
            Sorry, we couldn't find any vehicles with those search parameters.
        </div>

        <CarzRangeSearchPagination
            class="carzRangeSearchPage__pagination"
            :page="parseInt(pagination.page)"
            :per-page="pagination.perPage"
            :total-pages="pagination.totalPages"
            :total-results="pagination.totalResults"
            @prev="onDecreasePagination"
            @next="onIncreasePagination"
        />

    </div>
</template>

<script>
import CarzRangeSearchPagination from './CarzRangeSearchPagination.vue'
// import VehicleCard from '../../global/components/VehicleCard.vue'
import AutonomyVehicleCard from '../../global/components/AutonomyVehicleCard.vue'
import VehicleCardLoading from '../../global/components/VehicleCardLoading.vue'

export default {
    components: {
        CarzRangeSearchPagination,
        //VehicleCard,
        AutonomyVehicleCard,
        VehicleCardLoading,
    },
    props: {
        zeroPaymentSettings: {
            type: Object,
            default: () => {},
        },
        category: {
            type: String,
            default: 'core'
        },
        vehicleType: {
            type: String,
            default: 'cars'
        }
    },
    data() {
        return {
            loading: false,
            loaded: false, // initial loaded state
            filters: {
                makes: [],
                models: [],
                fuel: [],
                priceTypes: [
                    {
                        name: 'Cash',
                        value: 'cash'
                    },
                    {
                        name: 'Monthly',
                        value: 'monthly'
                    }
                ],
                priceRangeFrom: [],
                priceRangeTo: [],
                monthlyPriceRangeFrom: [],
                monthlyPriceRangeTo: [],
            },
            params: {
                make: '',
                model: '',
                fuel: '',
                priceType: 'cash',
                priceFrom: '',
                priceTo: '',
            },
            pagination: {
                perPage: 24,
                page: 1,
                totalPages: 1,
                totalResults: 0,
            },
            vehicles: [],
            isPriceBoxOpen: false
        }
    },
    created() {
        this.fetchVehicles()
    },
    methods: {
        async fetchVehicles() {
            this.loading = true;

            const formattedParams = {
                range_category: this.category,
                vehicle_type: this.vehicleType,
                make: this.params.make,
                model: this.params.model,
                fuel: this.params.fuel,
                price_type: this.params.priceType,
                price_from: this.params.priceFrom,
                price_to: this.params.priceTo,
                page: this.pagination.page,
                per_page: this.pagination.perPage
            }

            const params = new URLSearchParams(formattedParams).toString()

            try {
                const res = await fetch(`/sites/petervardy/templates/carz/ajax/range-filter.php?${params}`)

                if (!res.ok) {
                    throw new Error('Response not OK')
                }

                const json = await res.json()
                const { data, filters } = json

                if (data) {
                    const { data: vehicles, total, last_page  } = data
                    this.vehicles = vehicles
                    this.pagination.totalResults = total
                    this.pagination.totalPages = last_page
                }

                if (filters) {
                    const { makes, models, fuel, price_range_from: priceRangeFrom, price_range_to: priceRangeTo, monthly_price_range_from: monthlyPriceRangeFrom, monthly_price_range_to: monthlyPriceRangeTo } = filters
                    this.filters.makes = makes
                    this.filters.models = models
                    this.filters.fuel = fuel
                    this.filters.priceRangeFrom = priceRangeFrom
                    this.filters.priceRangeTo = priceRangeTo
                    this.filters.monthlyPriceRangeFrom = monthlyPriceRangeFrom
                    this.filters.monthlyPriceRangeTo = monthlyPriceRangeTo
                }
            } catch (e) {
                console.error(e)
            } finally {
                if (!this.loaded) {
                    this.loaded = true
                }

                this.loading = false
            }
            
        },
        onFilterChange(name, value) {
            Vue.set(this.params, name, value)
            this.resetPagination()
            this.fetchVehicles()
        },
        onMakeChange(value) {
            if (this.params.model !== '') {
                this.params.model = ''
            }

            this.onFilterChange('make', value)
        },
        onPriceTypeChange(value) {
            this.params.priceFrom = ''
            this.params.priceTo = ''
            this.params.priceType = value
        },
        formatCurrency(value, currency = 'GBP', options = {}) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
                maximumFractionDigits: 0,
                ...options,
            }).format(value)
        },
        onIncreasePagination() {
            this.pagination.page++
            this.fetchVehicles()
            this.scrollToFilterBar()
        },
        onDecreasePagination() {
            this.pagination.page--
            this.fetchVehicles()
            this.scrollToFilterBar()
        },
        onPriceBoxChange() {
            this.isPriceBoxOpen = !this.isPriceBoxOpen
        },
        scrollToFilterBar() {
            const ref = this.$refs.filter
            console.log({ ref })
            this.$refs.filter.scrollIntoView({ behavior: 'smooth' })
        },
        resetPagination() {
            this.pagination.page = 1
        }
    },
    computed: {
        priceRangeFrom() {
            // Get price range based on price type
            if (this.params.priceType === 'monthly') {
                return this.filters.monthlyPriceRangeFrom
            }

            return this.filters.priceRangeFrom
        },
        priceRangeTo() {
            if (this.params.priceType === 'monthly') {
                return this.filters.monthlyPriceRangeTo
            }

            return this.filters.priceRangeTo
        },
        priceRangeContext() {
            if (this.params.priceRangeFrom && this.params.priceRangeTo) {
                return `${this.formatCurrency(this.params.priceRangeFrom)} - ${this.formatCurrency(this.params.priceRangeTo)}`  
            }

            if (this.params.priceRangeFrom) {
                return `From ${this.formatCurrency(this.params.priceRangeFrom)}`
            }

            if (this.params.priceRangeTo) {
                return `To ${this.formatCurrency(this.params.priceRangeTo)}`
            }

            return 'Price'
        },
        loadingPlaceholders() {
            return (
                Math.min(this.pagination.perPage, this.pagination.totalResults) ||
                this.pagination.perPage
            );
        },
    },
}
</script>
